// Create a transport
import { createClient } from "@connectrpc/connect";
import { AdminService } from "@buf/alconostmt_services.bufbuild_es/alconost/mt/admin_pb";
import { createConnectTransport } from "@connectrpc/connect-web";

const transport = createConnectTransport({
    baseUrl: 'https://services-375925469890.us-central1.run.app',
    interceptors: [
        (next) => async (req) => {
            const token = localStorage.getItem('token');
            if (token) {
                req.header.set('Authorization', `Bearer ${token}`);
            }
            return next(req);
        }
    ]
});

const adminClient = createClient(AdminService, transport);

export const listEvaluations = async ({
    pageSize = 10,
    pageNumber = 1,
    status,
    searchTerm,
    sourceLanguage,
    targetLanguage
} = {}) => {
    try {
        const request = {
            pageSize,
            pageNumber,
            status,
            searchTerm,
            sourceLanguage,
            targetLanguage
        };

        // Remove undefined fields
        Object.keys(request).forEach(key =>
            request[key] === undefined && delete request[key]
        );

        const response = await adminClient.listEvaluations(request);
        return {
            evaluations: response.evaluations,
            totalCount: response.totalCount,
            pageCount: response.pageCount
        };
    } catch (error) {
        console.error('Error listing evaluations:', error);
        throw error;
    }
};

// Get evaluation statistics
export const getEvaluationStats = async () => {
    try {
        const response = await adminClient.getEvaluationStatistics()
            .then(convertBigIntsToNumbers)
        return response.stats;
    } catch (error) {
        console.error('Error getting evaluation stats:', error);
        throw error;
    }
};

export const evaluateAdminEvaluation = async (id, modelId) => {
    try {
        const request = {
            evaluationId: id,
            engine: modelId,
        };
        const response = await adminClient.evaluate(request);
        return response;
    } catch (error) {
        console.error('Error evaluating admin evaluation:', error);
        throw error;
    }
};

export const listMetrics = async ({
    pageSize = 10,
    pageNumber = 1
} = {}) => {
    try {
        const request = {
            pageSize,
            pageNumber
        };

        const response = await adminClient.listMetrics(request);
        return response;
    } catch (error) {
        console.error('Error listing metrics:', error);
        throw error;
    }
};

function convertBigIntsToNumbers(obj) {
    if (typeof obj === 'bigint') {
        return Number(obj); // or obj.toString() if you prefer to avoid precision issues
    }

    if (Array.isArray(obj)) {
        return obj.map(convertBigIntsToNumbers);
    }

    if (obj !== null && typeof obj === 'object') {
        return Object.fromEntries(
            Object.entries(obj).map(([key, value]) => [key, convertBigIntsToNumbers(value)])
        );
    }

    return obj;
}